//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";

// component
import MyPageMenu from "../../../../component/content/MyPageMenu";
import MyPageLevelBox from "../../../../component/content/MyPageLevelBox";
import InnerCon from "../../../../component/layouts/InnerCon";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MobileMyMain() {
    const [preOrder, setPreOrder] = useState(false);

    return (
        <Wrap>
            <MyPageTitle>MY PAGE</MyPageTitle>
            <MyPageSection>
                {/* 마이페이지 상단 등급 메뉴 */}
                <LevelBoxContent>
                    <MyPageLevelBox preOrder={preOrder} />
                </LevelBoxContent>
            </MyPageSection>

            {/* 마이페이지 사이드 메뉴 */}
            <MenuContent>
                <MyPageMenu preOrder={preOrder} />
            </MenuContent>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
    margin-bottom: ${M(165)};
`;
const MyPageTitle = styled.h2`
    font-family: "Pop-R";
    line-height: 1;
    font-size: ${M(20)};
    padding-left: ${M(25)};
`;
const MenuContent = styled.div`
    width: ${M(378)};
    margin: 0 auto;
`;
const MyPageSection = styled.div`
    margin-top: ${M(30)};
`;
const LevelBoxContent = styled.section`
    margin-bottom: ${M(30)};
`;
